<div class="tw-h-screen tw-w-full tw-flex">
  <mat-sidenav-container class="tw-flex-1 tw-h-full">
    <!-- Chat History Drawer (left side) -->
    <mat-sidenav
      mode="over"
      position="start"
      [opened]="historyDrawerOpen"
      class="tw-w-[85vw] xs:tw-w-[380px] sm:tw-w-[540px] md:tw-w-[600px] lg:tw-w-[700px] tw-p-3 sm:tw-p-4">
      <app-chat-history-drawer
        [orgId]="orgId"
        [isOpen]="historyDrawerOpen"
        (closeDrawer)="toggleHistoryDrawer()">
      </app-chat-history-drawer>
    </mat-sidenav>

    <!-- LEFT: Chat as main content -->
    <mat-sidenav-content class="tw-flex tw-flex-col tw-h-full">
      <!-- Header with chat controls and insights button - STICKY -->
      <div
        class="tw-sticky tw-top-0 tw-z-10 tw-flex tw-justify-between tw-items-center tw-px-2 sm:tw-px-4 tw-py-2 tw-border-b tw-border-gray-700 tw-bg-gray-900">
        <!-- Left side: History and New Chat buttons -->
        <div class="tw-flex tw-gap-1 sm:tw-gap-2 tw-items-center tw-min-w-0">
          <!-- Hamburger menu for mobile -->
          <button
            class="toggle-sidenav-btn tw-bg-gray-800 tw-p-2 tw-rounded tw-text-white hover:tw-bg-gray-700 tw-h-9 tw-flex tw-items-center tw-flex-shrink-0"
            (click)="toggleThinSidenav()"
            aria-label="Open menu"
            *ngIf="isSmallScreen$ | async">
            <svg
              class="tw-w-5 tw-h-5"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <button *ngIf="activeThreadId" mat-raised-button color="accent" (click)="startNewChat()" class="tw-flex-shrink-0">
            <mat-icon class="sm:tw-mr-1">edit_square</mat-icon>
            <span class="tw-hidden sm:tw-inline">Start New Chat</span>
          </button>

          <!-- LangGraph instance selector (non-production only, hidden on mobile) -->
          <app-langgraph-instance-selector
            *ngIf="langGraphInstanceService.isEnabled"
            class="tw-hidden md:tw-block">
          </app-langgraph-instance-selector>
        </div>

        <!-- Right side: Share button + Insights button -->
        <div class="tw-flex tw-items-center tw-gap-1 sm:tw-gap-2">
          <app-share-this-view
            *ngIf="activeThreadId && !isSharedThread"
            label="Share This Chat"
            [disabled]="isThreadBusy"
            disabledTooltip="Wait for the chat to finish before sharing"
            (shareClick)="shareChat()"
            class="tw-hidden sm:tw-block">
          </app-share-this-view>

          <button
            *ngIf="!sidenavOpened && activeThreadId && hasInsights"
            mat-icon-button
            (click)="sidenav.open()"
            class="tw-text-gray-300 hover:tw-text-teal-400 tw-transition-colors"
            [matTooltip]="(isSmallScreen$ | async) ? '' : 'Open Insights & Data'"
            matTooltipPosition="left">
            <mat-icon>insights</mat-icon>
          </button>
        </div>
      </div>

      <!-- PAL mode banner (unauthenticated user) -->
      <div *ngIf="isPalMode" class="tw-px-4 tw-pt-3">
        <app-alert
          alertType="info"
          [hasBorder]="false"
          [closeable]="false"
          [hideIcon]="true"
          class="tw-w-full">
          <div class="tw-flex tw-flex-row tw-gap-4 tw-justify-between tw-items-center">
            <div class="tw-flex tw-flex-col tw-gap-1">
              <div class="tw-text-base tw-text-white">
                You're viewing a shared snapshot of this chat<span *ngIf="al_created_at">
                  from {{ al_created_at | date:'MMMM d, yyyy' }}</span
                >.
              </div>
              <div class="tw-text-sm tw-text-gray-300">
                Sign up to start your own AI-powered workforce conversations.
              </div>
            </div>
            <button
              class="tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-base tw-font-medium tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-text-white tw-text-white tw-p-0.5">
              <span class="tw-relative tw-px-5 tw-py-2 tw-bg-gray-900 tw-text-white tw-rounded-md">
                Sign Up Free
              </span>
            </button>
          </div>
        </app-alert>
      </div>

      <!-- Shared thread banner (authenticated user viewing a shared chat) -->
      <div *ngIf="!isPalMode && isSharedThread" class="tw-px-4 tw-pt-3">
        <app-alert
          alertType="info"
          [hasBorder]="false"
          [closeable]="false"
          [hideIcon]="true"
          class="tw-w-full">
          <div class="tw-flex tw-flex-row tw-gap-4 tw-justify-between tw-items-center">
            <div class="tw-flex tw-flex-col tw-gap-1">
              <div class="tw-text-base tw-text-white">
                You're viewing a shared chat snapshot<span *ngIf="al_created_at">
                  from {{ al_created_at | date:'MMMM d, yyyy' }}</span
                >.
              </div>
              <div class="tw-text-sm tw-text-gray-300">
                This chat is read-only. Start a new chat to ask your own questions.
              </div>
            </div>
            <button mat-raised-button color="accent" (click)="startNewChat()" class="tw-shrink-0">
              <mat-icon class="tw-mr-1">edit_square</mat-icon>
              Start New Chat
            </button>
          </div>
        </app-alert>
      </div>

      <!-- Show new-chat component when no active thread -->
      <app-new-chat
        *ngIf="!activeThreadId"
        (messageSubmitted)="onMessageSubmitted($event)"
        class="tw-block tw-flex-1">
      </app-new-chat>

      <!-- Show chat component when there is an active thread -->
      <app-chat *ngIf="activeThreadId" [threadId]="activeThreadId" class="tw-block tw-flex-1">
      </app-chat>
    </mat-sidenav-content>

    <!-- RIGHT: Tabbed sidenav -->
    <mat-sidenav
      #sidenavContainer
      [mode]="sidenavMode"
      position="end"
      [style.width.px]="sidenavWidth"
      (openedChange)="sidenavOpened = $event"
      class="tw-bg-gray-900 sidenav-container-query">
      <!-- Resize handle (6px draggable) - only show in side mode -->
      <div
        *ngIf="sidenavMode === 'side'"
        class="sidenav-resize-handle tw-bg-gray-800 hover:tw-bg-gray-700 tw-transition-all tw-duration-300
        tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-[6px] tw-flex tw-items-center tw-justify-center tw-z-10"
        (mousedown)="startResize($event)">
        <button
          type="button"
          class="tw-rounded tw-bg-gray-800 hover:tw-bg-gray-700 tw-text-gray-300 tw-w-6 tw-h-9 tw-flex tw-items-center tw-justify-center tw-p-0 tw-outline-none tw-cursor-col-resize tw-transition-all tw-duration-300"
          aria-hidden="true">
          <mat-icon class="tw-text-base tw-w-4 tw-h-4">drag_handle</mat-icon>
        </button>
      </div>

      <!-- Header with close button -->
      <div
        class="tw-flex tw-justify-between tw-items-center tw-px-3 sm:tw-px-4 tw-py-1.5 sm:tw-py-2 tw-bg-gray-800 tw-border-b tw-border-gray-700">
        <div class="tw-text-base sm:tw-text-lg tw-text-gray-400">Related Data & Insights</div>
        <div class="tw-flex tw-items-center tw-gap-1">
          <button
            *ngIf="hasCompanyTabs()"
            mat-icon-button
            (click)="navigateToInsights()"
            class="tw-text-gray-400 hover:tw-text-teal-400 tw-transition-colors"
            matTooltip="Open in full Insights page"
            matTooltipPosition="below">
            <mat-icon>open_in_new</mat-icon>
          </button>
          <button mat-icon-button (click)="sidenav.close()" class="tw-text-gray-300">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Custom Tabbed Navigation -->
      <div class="tw-flex tw-flex-col tw-h-full tw-overflow-hidden">
        <!-- Tab Headers — Mobile: single scrollable row; Desktop: grouped with labels -->
        <div class="tw-bg-gray-800 tw-border-b tw-border-gray-700 tw-px-2 tw-pt-2 tw-pb-2">

          <!-- MOBILE: Compact single-row tabs (hidden on sm+) -->
          <div class="tw-flex sm:tw-hidden tw-gap-1 tw-overflow-x-auto tw-pb-1 mobile-tabs">
            <button
              *ngIf="isTabAvailable(4)"
              (click)="onTabChange(4)"
              [class.active]="activeTabIndex === 4"
              class="custom-tab custom-tab-compact tw-flex-shrink-0">
              <ng-container *ngIf="artifactPending; else codeIconMobile">
                <mat-spinner diameter="14" class="tw-flex-shrink-0"></mat-spinner>
              </ng-container>
              <ng-template #codeIconMobile>
                <mat-icon class="tw-text-base">code</mat-icon>
              </ng-template>
              <span>Artifacts</span>
            </button>
            <button
              *ngIf="isTabAvailable(0)"
              (click)="onTabChange(0)"
              [class.active]="activeTabIndex === 0"
              class="custom-tab custom-tab-compact tw-flex-shrink-0">
              <mat-icon class="tw-text-base">business</mat-icon>
              <span>In Depth</span>
            </button>
            <button
              *ngIf="isTabAvailable(1)"
              (click)="onTabChange(1)"
              [class.active]="activeTabIndex === 1"
              class="custom-tab custom-tab-compact tw-flex-shrink-0">
              <mat-icon class="tw-text-base">compare_arrows</mat-icon>
              <span>H2H</span>
            </button>
            <button
              *ngIf="isTabAvailable(2)"
              (click)="onTabChange(2)"
              [class.active]="activeTabIndex === 2"
              class="custom-tab custom-tab-compact tw-flex-shrink-0">
              <mat-icon class="tw-text-base">leaderboard</mat-icon>
              <span>Bench</span>
            </button>
            <button
              *ngIf="isTabAvailable(3)"
              (click)="onTabChange(3)"
              [class.active]="activeTabIndex === 3"
              class="custom-tab custom-tab-compact tw-flex-shrink-0">
              <mat-icon class="tw-text-base">table_chart</mat-icon>
              <span>Explore</span>
            </button>
          </div>

          <!-- DESKTOP: Grouped tabs with labels (hidden below sm) -->
          <div class="tw-hidden sm:tw-flex tw-flex-wrap tw-gap-1 tw-items-end">
            <!-- Artifacts Group -->
            <div *ngIf="isTabAvailable(4)" class="tw-flex tw-flex-col tw-gap-1">
              <div
                class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wider tw-font-medium tw-px-1">
                Artifacts
              </div>
              <div>
                <button
                  (click)="onTabChange(4)"
                  [class.active]="activeTabIndex === 4"
                  class="custom-tab">
                  <ng-container *ngIf="artifactPending; else codeIcon">
                    <mat-spinner diameter="14" class="tw-mr-1.5 tw-flex-shrink-0"></mat-spinner>
                  </ng-container>
                  <ng-template #codeIcon>
                    <mat-icon class="tw-text-base tw-mr-1.5">code</mat-icon>
                  </ng-template>
                  <span>Artifacts</span>
                </button>
              </div>
            </div>

            <!-- Separator -->
            <div
              *ngIf="isTabAvailable(4) && isTabAvailable(3)"
              class="tw-h-6 tw-w-px tw-bg-gray-600 tw-mx-1 tw-mb-2"></div>

            <!-- Companies Group -->
            <div *ngIf="hasCompanyTabs()" class="tw-flex tw-flex-col tw-gap-1">
              <div
                class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wider tw-font-medium tw-px-1">
                Companies
              </div>
              <div class="tw-flex tw-gap-1">
                <button
                  *ngIf="isTabAvailable(0)"
                  (click)="onTabChange(0)"
                  [class.active]="activeTabIndex === 0"
                  class="custom-tab">
                  <mat-icon class="tw-text-base tw-mr-1.5">business</mat-icon>
                  <span>In Depth</span>
                </button>
                <button
                  *ngIf="isTabAvailable(1)"
                  (click)="onTabChange(1)"
                  [class.active]="activeTabIndex === 1"
                  class="custom-tab">
                  <svg
                    class="tw-fill-[#a3a3a3] tw-mr-1.5"
                    height="20"
                    viewBox="0 -960 960 960"
                    width="22"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="m762-96-117-116-88 88-28-28q-23-23-23-57t23-57l169-169q23-23 57-23t57 23l28 28-88 88 116 117q12 12 12 28t-12 28l-50 50q-12 12-28 12t-28-12zm118-628-454 454 5 4q23 23 23 57t-23 57l-28 28-88-88-117 116q-12 12-28 12t-28-12l-50-50q-12-12-12-28t12-28l116-117-88-88 28-28q23-23 57-23t57 23l4 5 454-454h160zm-546 141 24-23 23-24-23 24zm-56 57-198-198v-160h160l198 198-57 56-174-174h-47v47l174 174zm92 199 430-430v-47h-47l-430 430zm0 0-24-23-23-24 23 24z" />
                  </svg>
                  <span>Head-to-Head</span>
                </button>
                <button
                  *ngIf="isTabAvailable(2)"
                  (click)="onTabChange(2)"
                  [class.active]="activeTabIndex === 2"
                  class="custom-tab">
                  <mat-icon class="tw-text-base tw-mr-1.5">leaderboard</mat-icon>
                  <span>Benchmark</span>
                </button>
              </div>
            </div>

            <!-- Separator -->
            <div
              *ngIf="hasCompanyTabs() && isTabAvailable(3)"
              class="tw-h-6 tw-w-px tw-bg-gray-600 tw-mx-1 tw-mb-2"></div>

            <!-- Data Group -->
            <div *ngIf="isTabAvailable(3)" class="tw-flex tw-flex-col tw-gap-1">
              <div
                class="tw-text-xs tw-text-gray-500 tw-uppercase tw-tracking-wider tw-font-medium tw-px-1">
                People Data
              </div>
              <div>
                <button
                  (click)="onTabChange(3)"
                  [class.active]="activeTabIndex === 3"
                  class="custom-tab">
                  <mat-icon class="tw-text-base tw-mr-1.5">table_chart</mat-icon>
                  <span>Explore</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Tab Content -->
        <div class="tw-flex-1 tw-overflow-hidden">
          <!-- Tab 1: Artifacts -->
          <div
            *ngIf="activeTabIndex === 4 && isTabAvailable(4)"
            class="tw-h-full tw-flex tw-flex-col">
            <!-- Artifact selector (only show if multiple artifacts) -->
            <div
              *ngIf="artifactsArray.length > 1"
              class="tw-px-3 sm:tw-px-4 tw-pt-3 sm:tw-pt-4 tw-pb-2 sm:tw-pb-3 tw-border-b tw-border-gray-700 tw-flex-shrink-0">
              <div class="tw-text-xs tw-text-gray-400 tw-mb-1.5 sm:tw-mb-2 tw-uppercase tw-tracking-wider">
                Artifact Sets
              </div>
              <div class="tw-flex tw-flex-wrap tw-gap-1.5 sm:tw-gap-2">
                <button
                  *ngFor="let artifact of artifactsArray; let i = index"
                  (click)="onArtifactSelectionChange(i)"
                  class="tw-px-3 sm:tw-px-4 tw-py-1.5 sm:tw-py-2 tw-rounded-md tw-transition-colors tw-font-medium tw-text-xs sm:tw-text-sm tw-cursor-pointer"
                  [ngClass]="{
                    'tw-bg-[#7FFFD4] tw-text-black': selectedArtifactIndex === i,
                    'tw-bg-gray-600 tw-text-white tw-border-2 tw-border-solid tw-border-teal-400': selectedArtifactIndex !== i
                  }">
                  Artifact Set {{ i + 1 }}
                </button>
              </div>
            </div>

            <!-- Artifact copy/paste buttons for admin only (hidden on mobile) -->
            <div
              *ngIf="isAdmin | async"
              class="tw-hidden sm:tw-block tw-px-4 tw-pt-4 tw-pb-3 tw-border-b tw-border-gray-700 tw-flex-shrink-0">
              <button
                mat-icon-button
                (click)="pasteArtifactData()"
                class="tw-text-gray-500 dark:tw-text-gray-400 hover:tw-text-primary_purple-500 dark:hover:tw-text-primary_purple-400"
                matTooltip="Paste Artifact JSON (Admin)">
                <mat-icon class="tw-text-[18px]">content_paste</mat-icon>
              </button>
              <button
                mat-icon-button
                (click)="copyArtifactCode()"
                class="tw-text-gray-500 dark:tw-text-gray-400 hover:tw-text-primary_purple-500 dark:hover:tw-text-primary_purple-400"
                matTooltip="Copy Artifact Code (Admin)">
                <mat-icon class="tw-text-[18px]">content_copy</mat-icon>
              </button>
            </div>

            <div class="tw-flex-1 tw-overflow-y-auto tw-px-4 tw-pb-4 tw-pt-4">
              <!-- Artifact pending state: artifact is still being generated -->
              <div
                *ngIf="artifactPending && !selectedArtifact"
                class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-gap-4">
                <mat-spinner diameter="40"></mat-spinner>
                <span class="tw-text-gray-400 dark:tw-text-gray-500 tw-text-sm"
                  >Generating artifacts...</span
                >
              </div>

              <app-artifact-renderer
                *ngIf="selectedArtifact"
                [artifact]="selectedArtifact"
                class="tw-block tw-h-full">
              </app-artifact-renderer>
            </div>
          </div>

          <!-- Tab 1: In Depth -->
          <div *ngIf="activeTabIndex === 0 && isTabAvailable(0)" class="tw-h-full">
            <div class="tw-flex tw-flex-col tw-h-full">
              <!-- Company selector (read-only, selection enabled for In Depth) -->
              <div class="tw-px-4 tw-py-3 tw-border-b tw-border-gray-700">
                <app-company-list-editor
                  [initialActiveList]="inDepthActiveList"
                  [initialSelectedCompanyIds]="inDepthSelectedCompanyIds"
                  [compactMode]="true"
                  [readOnly]="true"
                  [allowSelection]="true"
                  [multiSelect]="'off'"
                  (selectedCompaniesChange)="onInDepthCompanySelectionChange($event)">
                </app-company-list-editor>
                <a
                  class="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-teal-400 hover:tw-text-teal-300 tw-mt-2 tw-cursor-pointer tw-no-underline"
                  (click)="navigateToInsights('company')">
                  <mat-icon class="tw-text-sm tw-w-4 tw-h-4">open_in_new</mat-icon>
                  Open in Insights to filter by function, level, role, and more
                </a>
              </div>

              <!-- Dashboard content -->
              <div class="tw-flex-1 tw-overflow-y-auto tw-px-4 tw-pb-4 tw-pt-4">
                <app-insights-dashboard
                  [quickBuild]="inDepthQuickBuild"
                  [dateRangeStrings]="dateRangeStrings"
                  [mode]="'company'"
                  [chartConfigs]="chartConfigs"
                  [reportTarget]="reportTarget"
                  (chartConfigChange)="onChartConfigChange('inDepth', $event.chartId, $event.config)">
                </app-insights-dashboard>
              </div>
            </div>
          </div>

          <!-- Tab 2: Head-to-Head -->
          <div *ngIf="activeTabIndex === 1 && isTabAvailable(1)" class="tw-h-full">
            <div class="tw-flex tw-flex-col tw-h-full">
              <!-- Companies display (read-only, no selection for Head-to-Head) -->
              <div class="tw-px-4 tw-py-3  tw-border-b tw-border-gray-700">
                <app-company-list-editor
                  [initialActiveList]="headToHeadActiveList"
                  [initialSelectedCompanyIds]="selectedCompanyIds"
                  [compactMode]="true"
                  [readOnly]="true"
                  [allowSelection]="false"
                  [multiSelect]="'on'">
                </app-company-list-editor>
                <a
                  class="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-teal-400 hover:tw-text-teal-300 tw-mt-2 tw-cursor-pointer tw-no-underline"
                  (click)="navigateToInsights('battle')">
                  <mat-icon class="tw-text-sm tw-w-4 tw-h-4">open_in_new</mat-icon>
                  Open in Insights to filter by function, level, role, and more
                </a>
              </div>

              <!-- Dashboard content -->
              <div class="tw-flex-1 tw-overflow-y-auto tw-px-4 tw-pb-4 tw-pt-4">
                <app-insights-dashboard
                  [companyBattleQBs]="headToHeadQBs"
                  [dateRangeStrings]="dateRangeStrings"
                  [mode]="'battle'"
                  [chartConfigs]="chartConfigs"
                  [reportTarget]="reportTarget"
                  (chartConfigChange)="onChartConfigChange('headToHead', $event.chartId, $event.config)">
                </app-insights-dashboard>
              </div>
            </div>
          </div>

          <!-- Tab 3: Benchmark -->
          <div *ngIf="activeTabIndex === 2 && isTabAvailable(2)" class="tw-h-full">
            <div class="tw-flex tw-flex-col tw-h-full">
              <!-- Companies display (read-only, no selection for Benchmark) -->
              <div class="tw-px-4 tw-py-3  tw-border-b tw-border-gray-700">
                <app-company-list-editor
                  [initialActiveList]="benchmarkActiveList"
                  [initialSelectedCompanyIds]="selectedCompanyIds"
                  [compactMode]="true"
                  [readOnly]="true"
                  [allowSelection]="false"
                  [multiSelect]="'on'">
                </app-company-list-editor>
                <a
                  class="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-teal-400 hover:tw-text-teal-300 tw-mt-2 tw-cursor-pointer tw-no-underline"
                  (click)="navigateToInsights('benchmark')">
                  <mat-icon class="tw-text-sm tw-w-4 tw-h-4">open_in_new</mat-icon>
                  Open in Insights to filter by function, level, role, and more
                </a>
              </div>

              <!-- Dashboard content -->
              <div class="tw-flex-1 tw-overflow-y-auto tw-px-4 tw-pb-4 tw-pt-4">
                <app-insights-dashboard
                  [benchmarkCompanyQBs]="benchmarkQBs"
                  [dateRangeStrings]="dateRangeStrings"
                  [mode]="'benchmark'"
                  [chartConfigs]="chartConfigs"
                  [reportTarget]="reportTarget"
                  [selectedJobFunctions]="selectedJobFunctions"
                  [selectedJobLevels]="selectedJobLevels"
                  [selectedRole]="selectedRole"
                  (chartConfigChange)="onChartConfigChange('benchmark', $event.chartId, $event.config)">
                </app-insights-dashboard>
              </div>
            </div>
          </div>

          <!-- Tab 4: Data -->
          <div
            *ngIf="activeTabIndex === 3 && isTabAvailable(3)"
            class="tw-h-full tw-flex tw-flex-col">
            <!-- QuickBuild selector -->
            <div
              *ngIf="chatQuickBuilds.length > 0"
              class="tw-px-4 tw-pt-4 tw-pb-3 tw-border-b tw-border-gray-700 tw-flex-shrink-0">
              <div class="tw-text-xs tw-text-gray-400 tw-mb-2 tw-uppercase tw-tracking-wider">
                Relevant Data Sets
              </div>
              <div class="tw-flex tw-flex-wrap tw-gap-2">
                <button
                  *ngFor="let qb of chatQuickBuilds; let i = index"
                  (click)="onQuickBuildSelectionChange(i)"
                  class="tw-px-4 tw-py-2 tw-rounded-md tw-transition-colors tw-font-medium tw-text-sm tw-cursor-pointer"
                  [ngClass]="{
                    'tw-bg-[#7FFFD4] tw-text-black': selectedQuickBuildIndex === i,
                    'tw-bg-gray-600 tw-text-white tw-border-2 tw-border-solid tw-border-teal-400': selectedQuickBuildIndex !== i
                  }">
                  {{ qb.name || 'QuickBuild ' + (i + 1) }}
                </button>
              </div>
            </div>

            <!-- Filters component in embedded mode -->
            <div class="tw-flex-1 tw-overflow-hidden tw-p-4">
              <app-filters
                [setQuickBuild]="quickBuildForFilters"
                embedded="true"
                (searchCountChange)="matchingRecords = $event"
                class="tw-block tw-h-full">
              </app-filters>
            </div>

            <!-- Sticky Footer with Download Button -->
            <div
              class="tw-p-4 tw-bg-gray-900 tw-flex tw-justify-center tw-shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.2)] dark:tw-shadow-[0_-4px_6px_-1px_rgba(68,68,68,0.3)] tw-flex-shrink-0">
              <button
                class="tw-text-white tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-sm tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-from-blue-600 hover:tw-to-purple-600 focus:tw-outline-none focus:tw-ring-blue-500 tw-transition-all tw-p-0.5"
                [disabled]="!matchingRecords || matchingRecords === 0"
                [ngClass]="{'tw-opacity-50 tw-cursor-not-allowed': !matchingRecords || matchingRecords === 0}"
                [matTooltip]="!matchingRecords || matchingRecords === 0 ? 'No matching records found. Try adjusting your filters.' : ''"
                matTooltipPosition="above"
                [matTooltipDisabled]="matchingRecords > 0"
                (click)="downloadData()">
                <span
                  class="tw-relative tw-px-5 tw-py-2 tw-rounded-md tw-font-semibold tw-flex tw-items-center tw-gap-2">
                  <mat-icon class="tw-text-base">download</mat-icon>
                  Download Data
                  <span *ngIf="matchingRecords">({{ matchingRecords | number }})</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
